<div class="row">
  <div class="col-md-11 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center">
    <h2 class="default-pattern-color display-2 mb-4">{{designData?.features1?.main?.title}}</h2>
    <p class="lead fs-lg mb-11" [innerHTML]="designData?.features1?.main?.description"></p>
  </div>

</div>
<div class="text-container mb row gx-lg-0 gy-10 align-items-center mb-15 mb-md-17">

  <div class="col-lg-4 me-auto column-one-container w-100">
    <div *ngFor="let item of designData?.features2?.list; let i = index" class="d-flex flex-row mb-6">
      <div>
         <div class="spinner-center">
            <mat-spinner *ngIf="!item?.img"></mat-spinner>
        </div>
        <div class="svg-bg bg-white rounded-xl shadow-xl me-5">
            <img dynamicImage *ngIf="item?.img" [baseImageSrc]="item?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.sm, IMAGES_RESOLUTIONS.md]" class="svg-inject icon-svg solid-duo text-grape-fuchsia" alt="'itemImage ' + index" /> </div>
        </div>
      <div class="w-100">
        <h3 class="default-pattern-color mb-1">{{item?.title}}</h3>
        <p class="mb-0">{{item?.description}}</p>
      </div>
    </div>
  </div>

  <div class="col-lg-4 ms-auto column-two-container w-100">
    <div *ngFor="let item of designData.features1.list; let i = index" class="d-flex flex-row mb-6">
      <div>
         <div class="spinner-center">
            <mat-spinner *ngIf="!item?.img"></mat-spinner>
        </div>
        <div class="svg-bg bg-white rounded-xl shadow-xl me-5">
          <img dynamicImage *ngIf="item?.img" [baseImageSrc]="item?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.sm, IMAGES_RESOLUTIONS.md]" class="svg-inject icon-svg solid-duo text-grape-fuchsia" alt="'itemImage' + index" />
        </div>
      </div>
      <div class="w-100">
        <h3 class="default-pattern-color mb-1">{{item?.title}}</h3>
        <p class="mb-0">{{item?.description}}</p>
      </div>
    </div>
  </div>

</div>


